import {lazy} from "react";

const ReportUser = lazy(() => import("../pages/report/reportUser/ReportUser"));

export const reportRouter: any = [
  {path: "report/reportUser", element: <ReportUser/>},
]